import TrainingModulesService from "@/api/services/trainingModules";
import { toCamelCase } from "@estaly/ui";

// Last fetchIndex request started, so that a late response (e.g. of a previously selected store)
// does not overwrite the modules of a more recent one
let latestFetchIndexRequest = 0;

export default {
  namespaced: true,

  state: {
    trainingModules: [],
    currentModule: null,
    storesCompletion: null,
  },

  getters: {
    // The stores training follow-up needs several stores and a module with a quiz
    canFollowStoresCompletion: (state, _getters, _rootState, rootGetters) =>
      rootGetters["auth/accessibleStoreIds"].length >= 2 && state.trainingModules.some((module) => module.hasQuiz),
  },

  mutations: {
    SET_TRAINING_MODULES(state, trainingModules) {
      state.trainingModules = trainingModules;
    },
    SET_CURRENT_MODULE(state, trainingModule) {
      state.currentModule = trainingModule;
    },
    SET_STORES_COMPLETION(state, storesCompletion) {
      state.storesCompletion = storesCompletion;
    },
  },

  actions: {
    async fetchIndex({ commit }, storeIds) {
      const request = ++latestFetchIndexRequest;
      const response = await TrainingModulesService.fetchIndex(storeIds);
      if (request !== latestFetchIndexRequest) return { ...response, stale: true };
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("SET_TRAINING_MODULES", data.trainingModules);

      return response;
    },

    async fetchStoresCompletion({ commit }, storeIds) {
      const response = await TrainingModulesService.fetchStoresCompletion(storeIds);
      if (!response?.success) return response;

      commit("SET_STORES_COMPLETION", toCamelCase(response.data));

      return response;
    },

    async fetchModule({ commit }, moduleId) {
      const response = await TrainingModulesService.fetch(moduleId);
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("SET_CURRENT_MODULE", data.trainingModule);

      return response;
    },
  },
};
